import React from "react"
import cn from "classnames"
import { t } from "../../i18n"

interface Props {
  className?: string;
  children?: React.ReactNode;
  i18nKey?: string;
  i18nOptions?: Record<string, unknown>
}

const InfoBox = ({ className, children, i18nKey, i18nOptions }: Props): JSX.Element => {
  return (
    <div className={cn("InfoBox", className || "u-mt-sm")}>
      {i18nKey ? t(i18nKey, i18nOptions) : children}
    </div>
  )
}

export default InfoBox
